/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Settingid1Inputs */

const en_entity_settingid1 = /** @type {(inputs: Entity_Settingid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setting ID`)
};

const de_entity_settingid1 = /** @type {(inputs: Entity_Settingid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungs-ID`)
};

/**
* | output |
* | --- |
* | "Setting ID" |
*
* @param {Entity_Settingid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_settingid1 = /** @type {((inputs?: Entity_Settingid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Settingid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_settingid1(inputs)
	return de_entity_settingid1(inputs)
});
export { entity_settingid1 as "entity_settingId" }